{
  "about": {
    "paragraph": "Suntem angajați să abordăm provocările legii AGEC și să informăm clienții noștri despre originea și calitățile de mediu ale produselor noastre.",
    "title": "Despre"
  },
  "lastUpdate": "Data ultimei actualizări: ",
  "loading": {
    "dataPending": "colectează în prezent această informație",
    "pendingLocation": "Locație în așteptare"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Fabricarea îmbrăcămintei",
    "FOOTWEAR_FINISHING": "Finisarea încălțămintei",
    "FOOTWEAR_STITCHING": "Coaserea încălțămintei",
    "FOOTWEAR_ASSEMBLING": "Asamblarea încălțămintei",
    "FABRIC_WEAVING_OR_KNITTING": "Țeserea sau tricotarea țesăturilor",
    "FABRIC_DYEING_PRINTING": "Vopsirea sau imprimarea țesăturilor",
    "YARN_PROVIDER": "Furnizor de fire",
    "YARN_DYEING_PRINTING": "Vopsirea sau imprimarea firelor",
    "LEATHER_TANNING": "Tăbăcirea pielii",
    "LEATHER_DYEING_PRINTING": "Vopsirea sau imprimarea pielii",
    "ACCESSORY_PROVIDER": "Furnizor de accesorii",
    "YARN_MATERIAL_PRODUCTION": "Producția de materiale pentru fire",
    "FABRIC_SPINNING": "Filarea țesăturilor",
    "FABRIC_MATERIAL_PRODUCTION": "Producția de materiale textile",
    "LEATHER_MATERIAL_PRODUCTION": "Producția de materiale din piele",
    "LEATHER_FARM": "Fermă de creștere",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Furnizor de materii prime pentru accesorii",
    "COATING": "Acoperire"
  },
  "other": {
    "microplastics_bold": "eliberează microplastice ",
    "paragraph1": "Acest produs conține ",
    "paragraph1_100": "Acest produs conține 100% materiale reciclate.",
    "paragraph2_1": "Acest produs ",
    "paragraph2_2": "  în mediu în timpul spălării: ",
    "paragraph2_3": "în masă produsul este format din fibre sintetice.",
    "paragraph3": "Informații despre prezența potențială a substanțelor periculoase în aplicație: ",
    "recycled_matertials_bold": "cel puțin {{percent}}% materiale reciclate.",
    "recycled_matertials_bold_50": "mai mult de 50% ",
    "title": "Alte calități și caracteristici de mediu"
  },
  "packaging": {
    "recyclable": "Reciclabil: Ambalajul este reciclabil.",
    "recycled": "Materiale reciclate: Ambalajul conține cel puțin {{percent}}% materiale reciclate.",
    "recycled_100": "Materiale reciclate: Ambalajul conține 100% materiale reciclate.",
    "title": "Calitățile și caracteristicile de mediu ale ambalajului"
  },
  "title": "Fișa produsului privind calitățile sau caracteristicile de mediu",
  "traceability": {
    "paragraph": "Aceasta se referă la originea produsului dvs. în primele trei etape de producție, de la crearea sa până la țeserea și vopsirea materialului principal.",
    "title": "Urmărirea produsului"
  },
  "ecoScore": {
    "title": "EcoScore",
    "b2b": "Cost ambiental : {{cost}} puncte de impact"
  }
}
